module.exports = __webpack_public_path__ + "static/FX_PPPoE.39acf29e.jpg";